module.exports = __webpack_public_path__ + "static/17-001080a1be36b568e749319f720c7aeb.jpg";